exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".workload-full-details-table {\n  padding-top: 24px;\n  padding-bottom: 20px;\n  width: 100%;\n  overflow-x: auto; }\n\n.bolt-header-default + .workload-full-details-table {\n  padding-top: 8px; }\n\n.workload-column-key-padding {\n  padding-bottom: 4px; }\n\n.workload-tags-column-padding {\n  margin-left: 24px;\n  min-width: 150px; }\n\n.workload-card-content {\n  width: 100%; }\n  .workload-card-content .workload-image-padding {\n    padding: 0px; }\n\n.workload-image-column-size {\n  width: 300px;\n  min-width: 300px; }\n\n.workload-tags-column-size {\n  min-width: 150px; }\n", ""]);

// exports
